import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const CONFIRMATION_TEXT = "Hard Delete";

const BulkHardDeleteModal = ({
  show,
  onClose,
  onConfirm,
  isProcessing = false,
  error,
  users = [],
  isLoading = false,
  loadError,
}) => {
  const [confirmation, setConfirmation] = useState("");

  useEffect(() => {
    if (show) {
      setConfirmation("");
    }
  }, [show]);

  const pendingCount = users.length;
  const isConfirmed =
    confirmation.trim().toLowerCase() === CONFIRMATION_TEXT.toLowerCase();
  const canConfirm =
    isConfirmed && !isProcessing && !isLoading && pendingCount > 0;

  return (
    <Modal
      show={show}
      onHide={isProcessing ? undefined : onClose}
      aria-labelledby="bulk-hard-delete-modal"
      centered
    >
      <Modal.Header closeButton={!isProcessing}>
        <Modal.Title id="bulk-hard-delete-modal">Bulk Hard Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          You are about to permanently delete all users who requested a hard
          delete. This action is irreversible and will remove all associated
          data.
        </p>
        <div className="mb-3">
          <p className="mb-1 font-weight-bold">
            Users queued for hard delete ({pendingCount})
          </p>
          <div
            className="border rounded p-2"
            style={{ maxHeight: "200px", overflowY: "auto" }}
          >
            {isLoading ? (
              <div className="text-muted small">Loading users…</div>
            ) : loadError ? (
              <div className="text-danger small">{loadError}</div>
            ) : pendingCount > 0 ? (
              <ul className="mb-0 small list-unstyled">
                {users.map((u) => (
                  <li key={u.app_user_id}>
                    <strong>{u.email}</strong> ({u.app_user_id})
                  </li>
                ))}
              </ul>
            ) : (
              <div className="text-muted small">
                No users are currently flagged for hard delete.
              </div>
            )}
          </div>
        </div>
        <p className="mb-3">
          To confirm, type <strong>{CONFIRMATION_TEXT}</strong> in the field
          below and click Confirm.
        </p>
        <Form.Group>
          <Form.Label className="font-weight-bold">
            Type "{CONFIRMATION_TEXT}" to continue
          </Form.Label>
          <Form.Control
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            placeholder={CONFIRMATION_TEXT}
            disabled={isProcessing}
          />
        </Form.Group>
        {error ? (
          <Alert variant="danger" className="mt-3 mb-0">
            {error}
          </Alert>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isProcessing}>
          Cancel
        </Button>
        <Button
          variant="danger"
          disabled={!canConfirm}
          onClick={() => onConfirm()}
        >
          {isProcessing ? "Deleting..." : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BulkHardDeleteModal;
